import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

interface SimpleAreaChartProps {
  series: ApexAxisChartSeries;
  height?: string | number;
  color?: string;
  categories: string[];
}

const SimpleAreaChart: React.FC<SimpleAreaChartProps> = ({ series, height, color, categories }) => {
  const [options, setOptions] = useState<ApexCharts.ApexOptions>({
    chart: {
      id: "area-chart",
      type: "area",
      height: 100,
      zoom: {
        enabled: false,
      },
      sparkline: {
        enabled: true,
      },
      offsetY: 3,
    },
    stroke: {
      curve: "smooth",
    },
    colors: color ? [color] : ["#3e9ba2"],
    grid: {
      padding: {
        right: 0,
        left: 0,
      },
    },
    xaxis: {
      type: "datetime",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      categories: categories,
    },
    yaxis: {
      show: false,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yy",
      },
      shared: true,
      intersect: false,
    },
  });

  useEffect(() => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      xaxis: {
        ...prevOptions.xaxis,
        categories: categories,
      },
    }));
  }, [categories]);

  return <Chart options={options} series={series} type="area" height={height} />;
};

export default SimpleAreaChart;